import { createSelector } from 'reselect';

export const audienceInsightsStateSelector = state => state.audienceInsightsReducer;

export const segmentsMapSelector = createSelector(
    audienceInsightsStateSelector,
    audienceInsightsState => audienceInsightsState.segments
);
